import store from '@/core/store'
import {Alert} from '@/core/utils'
import VerificarPerfilUsuario from '@/core/utils/VerificarPerfilUsuario'
import {mutationTypes} from '@/core/constants'


const alert = new Alert(store)

class RouterGuards {
    async condicoes(to, from, next) {
        store.commit(mutationTypes.COMUM.SET_CURRENT_PAGE, to)
        this.validarPermissaoAdministrador(to, from, next)
    }

    validarPermissaoAdministrador(to, from, next) {
        if (to.meta.requiresAuth) {
            const possuiPermissao = VerificarPerfilUsuario(to.meta.perfis)

            if (possuiPermissao) {
                next()
            } else {
                alert.showError('O seu usuário não tem acesso a esta página.')
                next({name: 'perfilSemAcesso'})
            }
        } else {
            next()
        }
    }
}

export default new RouterGuards()
